import { getStatusBarHeight } from 'react-native-status-bar-height';

import BackgroundImage from './BackgroundImage';
import colors from './colors';
import fonts from './fonts';
import ThemeProvider, { ThemeConsumer, ThemeContext } from './ThemeProvider';
import withTheme from './withTheme';

export {
  BackgroundImage,
  colors,
  getStatusBarHeight,
  fonts,
  ThemeProvider,
  ThemeConsumer,
  ThemeContext,
  withTheme,
};
